import React, { memo } from "react";
import styled from "styled-components";

import { Executor } from "../../../../../../../../../../services";

const Cell = styled.span<{ $highlight?: boolean }>`
	display: block;
	width: 100%;
	padding: 0 4px;
	box-sizing: border-box;
	background: ${({ $highlight }) =>
		$highlight ? "rgba(208, 65, 65, 0.12)" : "transparent"};
`;

const TaxIdCellContent: React.FC<TaxIdCellContent.Props> = memo(({ item }) => {
	const taxId = String(item.taxId ?? "").trim();
	const enableFailed = !!item.electronicReceiptsEnableFailed;
	const highlight = enableFailed && !taxId;

	return <Cell $highlight={highlight}>{taxId || "—"}</Cell>;
});

declare namespace TaxIdCellContent {
	interface Props {
		item: Executor.Model;
	}
}

export default TaxIdCellContent;
